<template>
  <div class="filteritem">
  <p class="font-weight-bold text-text text-subtitle-1 pb-2">
    {{ selectorItem.SelectorName }} 
  </p> 



  <v-row class="pb-2">
    <v-col 
        class="py-0"
        cols="6" sm="4"  md="12" xxl="6"
        v-for="item in filteredItems"
        :key="item.Value"
    >
    <v-checkbox

    v-model="localValue" 
    :label="item.Title"
    :value="item.Value"
    density="compact"
    hide-details
    class="check"
    :class="[ { 'no-results': item.Count == 0 }]"
  />

    </v-col>
  </v-row>
  </div>
</template>
<style scoped>


.no-results :deep(.v-label) {
  color: #999;
  opacity: 0.7;
}

.no-results :deep(.v-selection-control__input) {
  opacity: 0.5;
}
</style>
<script setup>
const { $PAG } = useNuxtApp()

const props = defineProps({
  selectorItem: Object,
  pagData: Object,
  modelValue: {
    type: Array,  //  Array for checkboxes
    default: () => []
  }
})

const emit = defineEmits(['update:modelValue'])

// Local reactive value 
const localValue = computed({
  get: () => {
    // Ensure we always return an array
    const value = props.modelValue
    if (!value) {
      return []
    } else if (Array.isArray(value)){
      return value
    } else {
      return [value]  // Convert single value to array
    }
  },
  set: (value) => {
    // Emit array, or empty array if nothing selected
    emit('update:modelValue', value || [])
  }
})

// Computed items list
const items = computed(() => 
  $PAG.addItems(props.selectorItem.AttribuutSelectorName, props.pagData, props.selectorItem, true)
)
// Filter out items with Title === '-'
const filteredItems = computed(() => 
  items.value.filter(item => item.Title !== '-')
)
</script>